<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="time-to-let-her-rest-in-peace">
<p style="text-align: center; padding-top:90px; font-size:15pt; padding-bottom:30px;">‘Time to Let Her Rest in Peace’</p>
<p style="text-indent:0px;"><br/>The mystery is this:</p><br/>
<p style="text-indent:0px;">The more you go beyond yourself, the more you will become your true self.</p><br/>
<p style="text-indent:0px;">The more you lose yourself in loving and serving others, the more you will find yourself.</p><br/>
<p style="text-indent:0px;">The more you keep company with those who suffer, the more you will be healed.</p>
<br/>
<ul style="list-style-type:none; text-indent:0px;">
<li>Rt Revd Richard Chartres, Bishop of London, speaking at the tenth anniversary of the death of Diana, Princess of Wales.</li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?59ba5ab0